import React from 'react';

const Vue_v_bind = () => {
  return (
    <div>
      <h1>Vue_v_bind Component</h1>
      <p>This is the Vue_v_bind tutorial page.</p>
    </div>
  );
}

export default Vue_v_bind;
